// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLoader_wrapper__Zdn4Y","title":"AppLoader_title__l4Vlh","svg":"AppLoader_svg__BtFuI"};